export default {
      id: "check-usage",
      viewBox: "0 0 15 12",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }